import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import TalentRequestsPage from "@/pages/admin/TalentRequestsPage";

export const Route = createFileRoute("/_admin/admin/talent-requests")({
  head: () => pageHead("Admin · Talent Requests", "AKIVA admin · talent requests portal.", "/admin/talent-requests", true),
  component: TalentRequestsPage,
});
